import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Skeleton } from '../components/Skeleton';
import { PracticeInfo } from '../components/PracticeInfo';
import { useInitPractice } from '../hooks/useInitPractice';

export const Landing = () => {
  const { practiceId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, error, practice, init, token } = useInitPractice();

  useEffect(() => {
    if (!practiceId) return;
    const hasQueryParams = new URLSearchParams(location.search).toString().length > 0;
    if (!token) {
      init(practiceId)
        .then(() => {
            if (hasQueryParams) {
              navigate(`/bookonline/smart-booking${location.search}`, { replace: true });
            } else {
              navigate(`/bookonline/step-1`, { replace: true });
            }
        })
        .catch(() => {});
    } else {
      if (hasQueryParams) {
        navigate(`/bookonline/smart-booking${location.search}`, { replace: true });
      } else {
        navigate(`/bookonline/step-1`, { replace: true });
      }
    }
  }, [practiceId, init, navigate, token, location.search]);

  return (
    <Layout>
      {loading && <Skeleton lines={5} />}
      {!loading && error && (
        <div className="alert alert-error">
          <span>{error}</span>
        </div>
      )}
      {!loading && practice && (
        <div className="space-y-4">
          <PracticeInfo />
          <div className="text-sm text-gray-500">Preparing your booking experience…</div>
        </div>
      )}
    </Layout>
  );
};




